import React from 'react';

/**
 * Lista de escritorio con el estilo ORIGINAL del sistema
 * Exactamente igual a como están Presupuestos, Agendamientos y Usuarios
 */
export default function DesktopList({ 
  items = [], 
  onItemClick, 
  renderRow, 
  headers = [],
  emptyMessage = "No hay elementos para mostrar",
  className = "" 
}) {
  if (items.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="text-center py-12 text-gray-500">
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      {Array.isArray(items) && items.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {headers.map((header, index) => (
                  <th 
                    key={index}
                    className={`px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${
                      index === headers.length - 1 ? "sticky right-0 bg-gray-50 shadow-[-4px_0_8px_-4px_rgba(0,0,0,0.1)] z-10" : ""
                    }`}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {items.map((item, index) => (
                <tr 
                  key={item.id || item._id || index}
                  className="group hover:bg-gray-50 transition-colors"
                  onClick={() => onItemClick && onItemClick(item)}
                >
                  {renderRow(item, index)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <p>{emptyMessage}</p>
        </div>
      )}
    </div>
  );
}